/**
 * BroadcastStatusBadge — статус ручной рассылки
 * Дата: 26.02.2026 — PLAN Manual Broadcasts
 */
import { cn } from '@/utils/cn';

const STATUS_CONFIG: Record<string, { label: string; className: string }> = {
  draft: { label: 'Черновик', className: 'bg-neutral-200 text-neutral-700' },
  scheduled: { label: 'По расписанию', className: 'bg-blue-100 text-blue-800' },
  running: { label: 'Выполняется', className: 'bg-amber-100 text-amber-800 animate-pulse' },
  paused: { label: 'На паузе', className: 'bg-orange-100 text-orange-800' },
  completed: { label: 'Завершена', className: 'bg-green-100 text-green-800' },
  partially_completed: { label: 'Частично', className: 'bg-green-100 text-green-800 border border-amber-400' },
  cancelled: { label: 'Отменена', className: 'bg-red-100 text-red-800' },
  failed: { label: 'Ошибка', className: 'bg-red-100 text-red-800' },
};

interface BroadcastStatusBadgeProps {
  status: string;
  className?: string;
}

export function BroadcastStatusBadge({ status, className }: BroadcastStatusBadgeProps) {
  const config = STATUS_CONFIG[status] ?? { label: status, className: 'bg-neutral-100 text-neutral-600' };
  return (
    <span
      className={cn('inline-flex items-center px-2 py-0.5 rounded text-xs font-medium', config.className, className)}
      data-testid={`broadcast-status-${status}`}
    >
      {config.label}
    </span>
  );
}
